import React from 'react'
import {
    DisplayLicenseOption,
    DisplayTagOption,
    DisplayTimezoneOption,
    DisplaysAddMethods,
    IDisplaysAddProps,
    IState,
} from './displays__add.local.methods'
import EditText from 'blocks.simple/editText/editText'
import Button from 'blocks.simple/button/button'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import { SelectMapDialog } from 'features/map'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import { Radio } from 'atoms/Radio'
import { Scrollbars } from 'react-custom-scrollbars'
import helpersDisplays from 'core/helpers/_digitalSignages'
import helpers from 'core/helpers'
import { connect } from 'react-redux'
import { cn } from 'ethcss'
import styles from './displays__add.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import translate from 'core/translate'
import { colors, text as textStyles } from 'theme'
import { Typography } from 'atoms/Typography'
import { displaysAddActions } from './displays__add.state'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { displaysActions } from '../displays.state'
import { OpenStreetMap } from '../../../features/map/molecules/OpenStreetMap/OpenStreetMap-view'
import { SetPartialData } from '../__addGroup/displays__addGroup.local.methods'
import Icon from '../../../blocks.simple/icon/icon'
import { noEmoji } from 'core/utils/displayUtil'
import moment from 'moment'
import { MapLocationList } from 'features/map/atoms/MapLocationList'

const scrollBarStyles = {
    width: '100%',
    height: '100%',
}

const DisplaysAdd = (p_: IDisplaysAddProps) => {
    const {
        state,
        setState,
        onMapClose,
        getLocation,
        onChangeLocation,
        onChangePlacemarkGeometry,
        getCenter,
        onChangeAddress,
        onSelectAddressSuggestion,
        clearAddressSuggestions,
        getGroupsWithReplacedName,
        save,
        inputNullCheck,
        onMapOpen,
        getAddress,
        onValidateSymbolNumber,
        onSave,
        onClose,
    } = DisplaysAddMethods(p_)

    const getInputLabel = (textKey: string) => (
        <Typography type="title" className={styles.inputLabel}>
            {translate(textKey)}
        </Typography>
    )

    const renderMap = () => {
        const { active } = state

        const mapType = window?.spconfig?.map?.type

        return mapType !== 'yandex' && mapType !== 'google' ? (
            <OpenStreetMap
                onClose={onMapClose}
                isOpen={active}
                location={getLocation()}
                onChangeLocation={onChangeLocation}
                onChangePlacemarkGeometry={onChangePlacemarkGeometry}
            />
        ) : (
            <SelectMapDialog
                onClose={onMapClose}
                isOpen={active}
                location={getLocation()}
                center={getCenter()}
                onChangeLocation={onChangeLocation}
                onChangeAddress={onChangeAddress}
                onChangePlacemarkGeometry={onChangePlacemarkGeometry}
            />
        )
    }

    const checkEmptyLicences = (licences: any) => {
        return licences.some((licence: any) => licence.vacantCount)
    }

    const renderCustomOptions = (option: any) => {
        return (
            <div className={styles.licenseOption}>
                <div className={styles.licenseOptionRow} style={{ marginBottom: option.id ? 6 : 0 }}>
                    <div className={styles.licenseOptionName}>{option.name}</div>
                    {option.id && (
                        <div className={styles.licenseOptionDesc}>
                            {translate('licenseIdN')}: <span>{option.id}</span>
                        </div>
                    )}
                </div>
                {option.id && (
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseOptionDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {option.vacantCount}/<span>{option.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseOptionDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {option.expiredAt
                                    ? moment(option.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const renderCustomSelected = (licenseId: any) => {
        const license: any = state.licensesData && state.licensesData.find((item: any) => item.id === licenseId)

        return (
            license && (
                <div>
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseOptionName}>{license.name}</div>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('licenseIdN')}: <span>{license && license.id}</span>
                        </div>
                    </div>
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {license.vacantCount}/<span>{license.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {license.expiredAt
                                    ? moment(license.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                </div>
            )
        )
    }

    //@ts-ignore
    let groups = getGroupsWithReplacedName(p_.groups)
    let disabled = false

    if (helpersDisplays.isCheckLicenseQ()) {
        if (!helpersDisplays.checkActualLicense(p_.data.licenseId, state.licensesData)) {
            disabled = true
        }
    }

    return (
        <Scrollbars style={scrollBarStyles}>
            <form
                className={styles.deviceParametersWrapper}
                onSubmit={(e) => {
                    e.preventDefault()

                    if (state.active) {
                        return
                    }
                    save()
                }}
            >
                <Typography className={cn(styles.title)} type="title">
                    {translate('displayInfo')}
                </Typography>
                <div className={styles.content}>
                    <div className={styles.formWrapper}>
                        <div className={styles.form}>
                            <div className={styles.leftColumnContent}>
                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                    <EditText
                                        disabled={disabled}
                                        validationBorder={!!(state.data && state.data.error)}
                                        label={getInputLabel('name')}
                                        id="name"
                                        mod="withBorder"
                                        type="text"
                                        className={cn(textStyles.center, styles.noBoxShadow)}
                                        value={p_.data.name}
                                        onChange={(name: string) => {
                                            p_.setPartialData({ name })
                                            inputNullCheck(name, 'name')
                                        }}
                                    />
                                    <div
                                        className={cn(
                                            grid.mt_micro,
                                            textStyles.centerBlock,
                                            state.data && state.data.error ? '' : item.hidden,
                                            item.errorInputText
                                        )}
                                    >
                                        {translate('fieldIsRequired')}
                                    </div>
                                </div>
                                <div
                                    className={cn(styles.addressField, grid.mb_md, { [styles.disabled]: disabled })}
                                    onClick={function (e) {
                                        e.stopPropagation()
                                    }}
                                >
                                    <EditText
                                        label={getInputLabel('address')}
                                        id="address"
                                        mod="withBorder"
                                        type="text"
                                        icon="location"
                                        placeholder={translate('selectAddressOnMap')}
                                        className={cn(textStyles.center, styles.noBoxShadow)}
                                        onIconClick={onMapOpen}
                                        value={getAddress()}
                                        onChange={onChangeAddress}
                                        onBlur={() => {
                                            setTimeout(clearAddressSuggestions, 200)
                                        }}
                                        disabled={disabled}
                                    />
                                    {state.addressSuggestions.length > 0 && (
                                        <div
                                            className={styles.addressSuggestions}
                                            onMouseDown={(e) => e.preventDefault()}
                                        >
                                            <MapLocationList
                                                list={state.addressSuggestions}
                                                onSelect={onSelectAddressSuggestion}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={styles.descriptionWrapper}>
                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                    <EditText
                                        disabled={disabled}
                                        label={getInputLabel('description')}
                                        id="description"
                                        mod="withBorder"
                                        className={cn(styles.noBoxShadow)}
                                        type="area"
                                        rows="6"
                                        value={p_.data.description}
                                        onChange={function (description: string) {
                                            p_.setPartialData({ description })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.leftColumnContent}>
                            <div className={cn(grid.mb_md, item.rel, { [styles.disabled]: disabled })}>
                                {p_.groups && (
                                    <Dropdown
                                        id="group"
                                        disabled={disabled}
                                        label={getInputLabel('group')}
                                        value={p_.data.groupId}
                                        options={groups}
                                        centered
                                        searchable
                                        type="tree"
                                        onChange={function (selected: { id: number }) {
                                            p_.setPartialData({ groupId: selected.id })
                                        }}
                                    />
                                )}
                            </div>
                            {state.initGroup !== p_.data.groupId && (
                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                    <Checkbox
                                        onClick={function (checked: boolean) {
                                            p_.setPartialData({ overwriteSettings: checked })
                                        }}
                                        className={cn(grid.p_micro)}
                                        checked={p_.data.overwriteSettings}
                                        label={
                                            <Typography
                                                type="title"
                                                className={cn(
                                                    textStyles.normal,
                                                    grid.pl_mini,
                                                    grid.pr_mini,
                                                    textStyles.normal
                                                )}
                                            >
                                                {translate('applyGroupSettings')}
                                            </Typography>
                                        }
                                        disabled={disabled}
                                    />
                                </div>
                            )}
                            <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                <div
                                    className={cn(
                                        grid.mb_mini,
                                        textStyles.up,
                                        textStyles.normalPlus,
                                        textStyles.centerBlock,
                                        textStyles.normal
                                    )}
                                >
                                    <Typography type="title">{translate('timezones')}</Typography>
                                </div>
                                <Checkbox
                                    disabled={disabled}
                                    className={cn(grid.p_micro)}
                                    label={
                                        <div className={cn(grid.pl_mini, grid.pr_mini, textStyles.normal)}>
                                            <Typography type="title">{translate('useGroupTimezone')}</Typography>
                                        </div>
                                    }
                                    checked={state.groupTimezone}
                                    onClick={(checked: boolean) => {
                                        setState((prevState: IState) => ({
                                            ...prevState,
                                            groupTimezone: checked,
                                        }))
                                    }}
                                />
                            </div>
                            <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                <Dropdown
                                    id={'timezones'}
                                    value={
                                        state.groupTimezone
                                            ? state.parentTimezone
                                                ? state.parentTimezone
                                                : p_.data.timezone
                                            : p_.data.timezone
                                    }
                                    validationBorder={!!(state.data && state.data.nullTimezoneError)}
                                    options={p_.timezones}
                                    placeholder={translate('notSelected')}
                                    searchable
                                    centered
                                    onChange={(selected: DisplayTimezoneOption) => {
                                        p_.setPartialData({ timezone: selected.id })
                                        p_.setPartialData({ timezoneAbbr: selected.timezoneAbbr })
                                        p_.setPartialData({ timezoneOffset: selected.gmtOffset / 60 })
                                        inputNullCheck(selected.id, 'timezone')
                                        inputNullCheck(selected.timezoneAbbr, 'timezoneAbbr')
                                        inputNullCheck(selected.gmtOffset, 'gmtOffset')
                                    }}
                                    labelClassName={cn(item.ellipsis)}
                                    disabled={state.groupTimezone || disabled}
                                />
                                <div
                                    className={cn(
                                        grid.mt_micro,
                                        textStyles.centerBlock,
                                        state.data && state.data.nullTimezoneError ? '' : item.hidden,
                                        item.errorInputText
                                    )}
                                >
                                    {translate('fieldIsRequired')}
                                </div>
                            </div>
                            {!(p_.data.settings && p_.data.settings.monitorSettings) ? (
                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                    <Dropdown
                                        disabled={disabled}
                                        searchable
                                        value={p_.data.orientation}
                                        label={getInputLabel('orientation')}
                                        options={helpersDisplays.getOrientations(p_.data.platform)}
                                        onChange={function (value) {
                                            p_.setPartialData({ orientation: value.id })
                                        }}
                                        centered
                                    />
                                </div>
                            ) : (
                                <div className={cn(grid.mb_md, styles.orientationWrapper)}>
                                    <div className={styles.orientationTitle}>{translate('orientation')}</div>
                                    {translate('orientationDesc')}
                                </div>
                            )}
                            {helpers.isAvailableAction(null, {
                                key: 'DSNotifications',
                                action: 'update',
                            }) && (
                                <>
                                    <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                        <Dropdown
                                            searchable
                                            value={p_.data.DSNotificationsData && p_.data.DSNotificationsData.unitId}
                                            placeholder={translate('notSelected')}
                                            label={
                                                <Typography
                                                    type="title"
                                                    className={cn(
                                                        textStyles.up,
                                                        textStyles.centerBlock,
                                                        textStyles['normalPlus'],
                                                        grid.mb_micro
                                                    )}
                                                >
                                                    {translate('DSNotificationUnit')}
                                                </Typography>
                                            }
                                            centered
                                            options={helpersDisplays.getUnitListOptions(state.unitList)}
                                            onChange={(value) => {
                                                p_.setPartialData({
                                                    DSNotificationsData: { unitId: value.id, floorId: null },
                                                })
                                            }}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                        <Dropdown
                                            searchable
                                            value={p_.data.DSNotificationsData && p_.data.DSNotificationsData.floorId}
                                            label={
                                                <Typography
                                                    type="title"
                                                    className={cn(
                                                        textStyles.up,
                                                        textStyles.centerBlock,
                                                        textStyles['normalPlus'],
                                                        grid.mb_micro
                                                    )}
                                                >
                                                    {translate('floor')}
                                                </Typography>
                                            }
                                            centered
                                            placeholder={translate('notSelected')}
                                            options={helpersDisplays.getUnitFloorListOptions(
                                                state.unitList,
                                                p_.data.DSNotificationsData
                                            )}
                                            onChange={(value) => {
                                                if (p_.data.DSNotificationsData) {
                                                    p_.setPartialData({
                                                        DSNotificationsData: {
                                                            unitId: p_.data.DSNotificationsData.unitId,
                                                            floorId: value.id,
                                                        },
                                                    })
                                                }
                                            }}
                                            disabled={disabled}
                                        />
                                    </div>
                                </>
                            )}
                            {helpers.isAvailableAction(null, {
                                key: 'bksDepartment',
                                action: 'update',
                            }) && (
                                <div className={cn(grid.mb_md, { [styles.disabled]: disabled })}>
                                    <EditText
                                        disabled={disabled}
                                        label={getInputLabel('departmentCode')}
                                        id="department"
                                        mod="withBorder"
                                        className={cn(textStyles.center, styles.noBoxShadow)}
                                        value={p_.data.department}
                                        onChange={function (department: string) {
                                            p_.setPartialData({ department })
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={styles.rightColumnContent}>
                            <div
                                className={cn(styles.displaysAdd__inputWrapper_type_tags, {
                                    [styles.disabled]: disabled,
                                })}
                            >
                                {p_.data.tags && p_.tagsList && (
                                    <Dropdown
                                        hiddenOverflow
                                        disabled={disabled}
                                        list={p_.data.tags}
                                        options={p_.tagsList}
                                        label={getInputLabel('tag')}
                                        searchable={true}
                                        multiselect={true}
                                        disableAddNewTags={
                                            !helpers.isAvailableAction(null, {
                                                key: 'digitalSignage',
                                                action: 'update',
                                                subaction: 'manageTags',
                                            })
                                        }
                                        onChange={function (tags: DisplayTagOption[]) {
                                            tags = tags
                                                .map((tag) => {
                                                    if (!tag.id && tag.name.match(/#/g)) {
                                                        tag.name = tag.label = tag.name.replace(/#/g, '')
                                                    }
                                                    tag = {
                                                        ...tag,
                                                        name: noEmoji(tag.name),
                                                        label: noEmoji(tag.label),
                                                    }
                                                    return tag
                                                })
                                                .filter(
                                                    (tag: DisplayTagOption, index: number, self: DisplayTagOption[]) =>
                                                        index === self.findIndex((t) => t.name === tag.name)
                                                )
                                            p_.setPartialData({ tags })
                                        }}
                                        onValidateSymbolNumber={(checked) => onValidateSymbolNumber(checked)}
                                    />
                                )}
                            </div>
                            {helpers.isAvailableAction(null, {
                                key: 'digitalSignage',
                                action: 'update',
                                subaction: 'manageTags',
                            }) && (
                                <div className={grid.mt_mini}>
                                    <Typography className={textStyles.centerBlock}>
                                        {translate('forAddTagUseEnter')}
                                    </Typography>
                                    {state.validateSymbolNumber && (
                                        <Typography className={cn(styles.centerBlock, grid.mt_mini)} type="error">
                                            {translate('minTagNumber')}
                                        </Typography>
                                    )}
                                </div>
                            )}
                            {helpersDisplays.isCheckLicenseQ() && (
                                <div className={cn(grid.mb_md, grid.mt_big, item.rel, styles.lic)}>
                                    <Dropdown
                                        id="licensesDataEdit"
                                        label={
                                            <Typography
                                                type="title"
                                                className={cn(
                                                    textStyles.up,
                                                    textStyles.centerBlock,
                                                    textStyles['normalPlus'],
                                                    grid.mb_mini
                                                )}
                                            >
                                                {translate('licensesType')}
                                            </Typography>
                                        }
                                        value={p_.data.licenseId}
                                        customListElement={renderCustomOptions}
                                        customButtonContent={renderCustomSelected(p_.data.licenseId)}
                                        options={[
                                            {
                                                name: translate('notSelected'),
                                                id: null,
                                            },
                                            ...state.licensesData.filter((item: any) => item.id !== p_.data.licenseId),
                                        ]}
                                        centered
                                        onChange={(selected: DisplayLicenseOption) => {
                                            setState((prevState: IState) => ({
                                                ...prevState,
                                                currentLicense: selected,
                                            }))
                                            p_.setPartialData({ licenseId: selected.id })
                                        }}
                                        buttonClassName={cn('test-device-license-dropdown', 'test-choose-license')}
                                        placeholder={translate('notSelected')}
                                    />
                                </div>
                            )}
                            {/* {state.currentLicense?.vacantCount ? (
                                    <div className={styles.license__info}>
                                        <Typography type="text">
                                            {translate('licensesBalance')} {state.currentLicense.vacantCount}{' '}
                                            {translate('licensesLeft')}
                                        </Typography>
                                    </div>
                                ) : state.currentLicense?.vacantCount === 0 && this.checkEmptyLicences(state.licensesData) ? (
                                    <div className={styles.noLicensesLeft}>
                                        <Icon type={'info'} color={colors.notificationRed} />
                                        <span>{translate('noLicencesInTariff')}</span>
                                    </div>
                                ) : null} */}
                            {helpersDisplays.isCheckLicenseQ() && !checkEmptyLicences(state.licensesData) && (
                                <div className={styles.noLicensesLeft}>
                                    <Icon type={'info'} color={colors.notificationRed} />
                                    <span>{translate('noLicencesInTariffs')}</span>
                                </div>
                            )}
                            {state.initGroup !== p_.data.groupId && (
                                <div className={cn(grid.mt_mdPlus, { [styles.disabled]: disabled })}>
                                    <Typography
                                        type="title"
                                        className={cn(textStyles.centerBlock, textStyles.up, textStyles['normalPlus'])}
                                    >
                                        {translate('scheduleForDevice')}
                                    </Typography>
                                    <Radio
                                        className={cn(grid.mt_md)}
                                        label={
                                            <Typography type="title">{translate('changeCurrentSchedule')}</Typography>
                                        }
                                        selected={p_.data.groupScheduleMode === 'apply'}
                                        onClick={function () {
                                            p_.setPartialData({ groupScheduleMode: 'apply' })
                                        }}
                                        disabled={disabled}
                                    />
                                    <Radio
                                        className={cn(grid.mt_mini)}
                                        label={
                                            <Typography type="title">{translate('remainCurrentSchedule')}</Typography>
                                        }
                                        selected={p_.data.groupScheduleMode === 'ignore'}
                                        onClick={function () {
                                            p_.setPartialData({ groupScheduleMode: 'ignore' })
                                        }}
                                        disabled={disabled}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={styles.footer}>
                    {p_.isEdit && (
                        <Button mod="withBorder" className={cn(grid.mr_md)} onClick={onClose}>
                            {translate('cancel')}
                        </Button>
                    )}
                    <Button
                        mod="fill"
                        onClick={onSave}
                        disabled={
                            !helpersDisplays.isCheckLicenseQ()
                                ? (state.data && state.data.error) || (state.data && state.data.nullTimezoneError)
                                    ? true
                                    : false
                                : !!((state.data && state.data.error) || (state.data && state.data.nullTimezoneError))
                        }
                    >
                        {translate('save')}
                    </Button>
                </div>
                {renderMap()}
            </form>
        </Scrollbars>
    )
}

const mapStateToProps = (state: any) => {
    return {
        data: state.displays__add.data,
        isEdit: state.displays__add.isEdit,
        groups: state.displays.groups,
        tagsList: state.displays.tags,
        timezones: state.app.timezones,
        user: state.user.data.companyId,
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    setPartialData: (data: SetPartialData) => dispatch(displaysAddActions.setPartialData(data)),
    emitError: (err: string) => dispatch(emitError(err)),
    closeModal: () => dispatch(displaysActions.closeModal()),
    setGroups: (groups: any) => dispatch(displaysActions.setGroups(groups)),
    clearData: () => dispatch(displaysAddActions.clearData()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DisplaysAdd)
